import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M2.625 20.208a.75.75 0 1 1 0-1.5h.5v-7.375c0-.759.616-1.375 1.375-1.375H7c.76 0 1.375.616 1.375 1.375v7.375h1V3.833c0-.759.616-1.375 1.375-1.375h2.5c.76 0 1.375.616 1.375 1.375v14.875h1V7.583c0-.759.616-1.375 1.375-1.375h2.5c.76 0 1.375.616 1.375 1.375v11.125h.5a.75.75 0 0 1 .743.649l.007.101a.75.75 0 0 1-.75.75zm4.25-8.75h-2.25v7.25h2.25v-7.25zm12.5-3.75h-2.25v11h2.25v-11zm-6.25-3.75h-2.25v14.75h2.25V3.958z' />
  </svg>
);
